export class WinDistribution {
  public constructor(public labels: string[], public wins: number[]) {}
}
